import React, { useState, useEffect } from "react";
import { Autocomplete } from "@mui/material";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import useBuscaSelecaoMultipla from "../../hooks/useBuscaSelecaoMultipla";

const TicketsWhatsappSelect = ({ whatsApps = [], selectedWhatsAppIds = [], onChange }) => {
	const [selectedIds, setSelectedIds] = useState([]);

	useEffect(() => {
		setSelectedIds(whatsApps.filter(whatsApp => selectedWhatsAppIds.includes(whatsApp.id)));
	}, [selectedWhatsAppIds, whatsApps]);

	const handleChange = (event, newValue) => {
		// Verifica se "Selecionar Tudo" foi clicado
		if (newValue.some((option) => option.id === "toggle-all")) {
			if (selectedWhatsAppIds.length === whatsApps.length) {
				setSelectedIds([]);
				onChange([]);
			} else {
				setSelectedIds(whatsApps);
				onChange(whatsApps.map((whatsApp) => whatsApp.id));
			}
		} else {
			setSelectedIds(newValue);
			onChange(newValue.map((whatsApp) => whatsApp.id));
		}
	};

	// Mantém o texto da busca ao marcar itens (o MUI limpa por padrão).
	const busca = useBuscaSelecaoMultipla();

	return (
		<Autocomplete
			multiple
			options={[{ id: "toggle-all", name: "Selecionar Tudo" }, ...whatsApps]}
			getOptionLabel={(option) => option.name}
			value={selectedIds}
			disableCloseOnSelect
			{...busca}
			onChange={handleChange}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			ListboxProps={{
				style: {
					maxHeight: 300,
					overflowY: 'auto',
					fontSize: '0.85rem',
				},
			}}
			sx={{
				fontSize: '0.85rem', // fonte geral do componente
				'& .MuiAutocomplete-inputRoot': {
					padding: '4px !important',
					fontSize: '0.85rem',
				},
			}}
			renderTags={() => null}
			renderOption={(props, option, { selected }) => (
				<MenuItem
					{...props}
					dense
					sx={{
						fontSize: '0.85rem',
						minHeight: '32px',
						paddingY: 0.5,
					}}
				>
					<Checkbox
						color="primary"
						checked={
							option.id === "toggle-all"
								? selectedWhatsAppIds.length === whatsApps.length
								: selected
						}
						indeterminate={
							option.id === "toggle-all" &&
							selectedWhatsAppIds.length > 0 &&
							selectedWhatsAppIds.length < whatsApps.length
						}
						sx={{
							padding: '4px',
							'& svg': { fontSize: '18px' },
						}}
						style={{ color: option.color || "inherit" }}
					/>
					<ListItemText
						primary={option.name}
						primaryTypographyProps={{ fontSize: '0.85rem' }}
					/>
				</MenuItem>
			)}
			renderInput={(params) => (
				<TextField
					{...params}
					label="Filtrar por conexão"
					variant="outlined"
					margin="dense"
					InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
					placeholder={selectedWhatsAppIds.length === 0 || selectedWhatsAppIds.length >= whatsApps.length
						? `Todas (${whatsApps.length})`
						: `${selectedWhatsAppIds.length} de ${whatsApps.length}`}
					sx={{
						'& input': {
							fontSize: '0.85rem',
						},
						'& label': {
							fontSize: '0.85rem',
						},
					}}
				/>
			)}
		/>

	);
};

export default TicketsWhatsappSelect;
